export default __webpack_public_path__ + "static/media/tz.976dcabc.svg";